import React__default from 'react';
import { F as FormIdContext } from './FormIdContext-BvlItbMu.js';

const FormIdProvider = ({
  value,
  children
}) => /*#__PURE__*/React__default.createElement(FormIdContext.Provider, {
  value: value
}, children);

export { FormIdProvider as F };
//# sourceMappingURL=FormIdProvider-B_7kO2ZK.js.map
